import animateDuringTransition from "./animateDuringTransition";
export default function updateSizeDuringTransition(map) {
    return animateDuringTransition(map, () => {
        map.updateSize();
    });
}
